var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.items.length > 0,
      expression: "items.length > 0"
    }],
    staticClass: "notifications"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l(_vm.items, function (notif) {
    return _c('div', {
      key: notif.id,
      staticClass: "notif_item"
    }, [_c('p', {
      staticClass: "notif_title",
      style: {
        backgroundColor: notif.color
      }
    }, [_vm._v(" " + _vm._s(notif.title) + " ")]), _c('p', {
      staticClass: "notif_msg"
    }, [_vm._v(_vm._s(notif.message))])]);
  }), 0)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }